// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3z5xT","header":"PatientQuestionnaire_header__3SIf-","info":"PatientQuestionnaire_info__1pW_c"};